
(function(template){
  define('vue!optionalClassProgram/components/userComponents/loggedInUserComponents/loggedInUserComponent',[
    "Vue",
    "helpers",
    "vuex",
    'vue!./innerComponent'

  ], function (
    Vue,
    helpers,
    vuex,
    innerComponent
  ) {
    return {
      template: template,
      name: "",
      computed: _.extend(
        vuex.mapState(['users','usersWithIds']), {}),
      components: {
          'innerComponent':innerComponent
      },
    }
  })
})('<div> <div class="accordion" id="accordion3"> <div class="accordion-group optional-class-user-accordion" v-show="value.isBookingClass" v-for="(value, key, lgIndex) in users" :key="lgIndex"> <div class="accordion-heading"> <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion3" :data-target="\'#lg\'+lgIndex"> <span class="optionalclass-accordion-header-text">{{usersWithIds[key]}}</span> </a> </div> <div></div> <innerComponent v-bind:lgIndex="lgIndex" v-bind:customerID="key"></innerComponent> </div> </div> </div>');
